import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { MdSave } from 'react-icons/md';

import SuccessChangePasswordModal from './SuccessChangePasswordModal';
import { useSelector } from 'react-redux';

import { SubmitBtn } from '@components/StyledComponent';
import { RootState } from 'app/store';
import ButtonActionStatus from '@pages/OrganizedSales/CreateOrders/common/ButtonActionStatus';
import { CheckOutlined, LoadingOutlined } from '@ant-design/icons';
import { Form, Input, Spin, message } from 'antd';
import AuthServiceApi from 'apis/api/Auth';

type TypeUpdatePassword = {
  OldPassword: any;
  NewPassword: any;
  ConfirmPassword: any;
};

const initalForm: TypeUpdatePassword = {
  OldPassword: '',
  NewPassword: '',
  ConfirmPassword: ''
};

export default function UpdateUserPassword() {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  // Selector
  const account = useSelector((state: RootState) => state.user.account);

  // State
  const [showSuccessUpdatePassword, setShowSuccessUpdatePassword] = useState<boolean>(false);
  const [confirmLoading, setConfirmLoading] = useState<boolean>(false);
  // useEffect(() => {
  //   if (user) {
  //     const mask = getBit(user.Theme, 4);
  //     if (mask === 1) {
  //       // console.log('RenderData', 'không cho đổi mạt khẩu');
  //       setNoUpdatePassWord(true);
  //     }
  //   }
  // }, [user]);

  // function getBit(number: any, bitPosition: any) {
  //   return (number & (1 << bitPosition)) === 0 ? 0 : 1;
  // }

  const handleFormSubmit = async (evt: TypeUpdatePassword) => {
    if (account) {
      setConfirmLoading(true);
      // const isMatchOldPass = await Helpers.CompareWithOldPassword(account?.UserName, evt.OldPassword); // đăng nhập thử để coi đúng password k
      const request = {
        OldPassword: evt.OldPassword,
        NewPassword: evt.NewPassword,
        reEnterNewPassword: evt.ConfirmPassword
      };
      try {
        await AuthServiceApi.ChangePassword(request.OldPassword, request.NewPassword, request.reEnterNewPassword).then(
          res => {
            if (!res.data.error) {
              setShowSuccessUpdatePassword(true);
            } else {
              message.error(
                t(res.data.message) + '. ' + res.data.messageCode == 'PWD_INVALID'
                  ? 'Độ dài ký tự phải lớn hơn 5'
                  : res.data.messageCode == 'DATA_DOES_NOT_EXIST'
                  ? 'Tài khoản không tồn tại'
                  : res.data.messageCode == 'OLD_PASSWORD_MISMATCHED'
                  ? 'PassWord cũ không đúng'
                  : 'Password xác nhận không khớp'
              );
            }
          }
        );
        setConfirmLoading(false);
      } catch (error) {
        setConfirmLoading(false);
        message.error(t('Header.UserAcount.Error.UpdatePasswordError'));
      }
    }
  };

  return (
    <>
      {showSuccessUpdatePassword && <SuccessChangePasswordModal isOpen={showSuccessUpdatePassword} />}
      <div className="my-4">
        <Form form={form} layout="vertical" onFinish={handleFormSubmit}>
          <Form.Item
            label={t('Header.UserAcount.OldPassword')}
            name={'OldPassword'}
            rules={[
              {
                required: true,
                // whitespace: true,
                message: t('Input.FieldError.RequireText')
              }
            ]}
            style={{ marginBottom: 2 }}
          >
            <Input style={{ width: '100%' }} placeholder={t('Input.placeholder')} />
          </Form.Item>
          <Form.Item
            className="flex flex-col"
            label={t('Header.UserAcount.NewPassword')}
            name={'NewPassword'}
            rules={[
              {
                required: true,
                // whitespace: true,
                message: t('Input.FieldError.RequireText')
              },
              { min: 6, message: t('Header.UserAcount.PasswordRe6Char') }
            ]}
            style={{ marginBottom: 2 }}
          >
            <Input style={{ width: '100%' }} placeholder={t('Input.placeholder')} />
          </Form.Item>
          <Form.Item
            className="flex flex-col"
            label={t('Header.UserAcount.ConfirmPassword')}
            name={'ConfirmPassword'}
            rules={[
              {
                required: true,
                // whitespace: true,
                message: t('Input.FieldError.RequireText')
              },
              { min: 6, message: t('Header.UserAcount.PasswordRe6Char') },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('NewPassword') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error(t('Input.FieldError.NotMacthPassWord')));
                }
              })
            ]}
            dependencies={['NewPassword']}
          >
            <Input style={{ width: '100%' }} placeholder={t('Input.placeholder')} />
          </Form.Item>
        </Form>
        <ButtonActionStatus
          showButton={true}
          onClick={form.submit}
          icon={
            <span className="mr-2">
              {confirmLoading ? (
                <LoadingOutlined rev={''} style={{ fontSize: '21px', transform: 'translateY(-3px)' }} />
              ) : (
                <CheckOutlined rev={''} style={{ fontSize: '21px', transform: 'translateY(-3px)' }} />
              )}
            </span>
          }
          text={t('Button.Save')}
          type="primary"
        />
      </div>
    </>
  );
}
